import { Pagination } from '@mui/material';
import { debounce } from 'lodash';
import React, { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const PaginationInput = () => {
    const { setValue, handleSubmit } = useFormContext();
    const totalPages = useWatch({ name: 'totalPages' });
    const page = useWatch({ name: 'page' });
    const items = useWatch({ name: 'items' });

    const handleChange = useCallback(
        debounce((_event, value) => {
            setValue('page', value);
            handleSubmit();
        }, 600),
        []
    );

    if (!items || items.length < 1) return null;

    return (
        <Pagination
            key={page}
            count={totalPages}
            defaultPage={page}
            onChange={handleChange}
            sx={{
                '& .MuiPaginationItem-root': {
                    fontSize: '16px'
                }
            }}
        />
    );
};
